/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AirlineDto } from '../models/airline-dto';
import { AjaxResponseOfListOfAirlineDto } from '../models/ajax-response-of-list-of-airline-dto';

@Injectable({
  providedIn: 'root',
})
export class AirlineCompanyService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getByName
   */
  static readonly GetByNamePath = '/api/services/app/AirlineCompany/GetByName';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByName()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByName$Response(params?: {
    name?: string;
  }): Observable<StrictHttpResponse<Array<AirlineDto>>> {

    const rb = new RequestBuilder(this.rootUrl, AirlineCompanyService.GetByNamePath, 'get');
    if (params) {
      rb.query('name', params.name, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AirlineDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getByName$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByName(params?: {
    name?: string;
  }): Observable<Array<AirlineDto>> {

    return this.getByName$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AirlineDto>>) => r.body as Array<AirlineDto>)
    );
  }

  /**
   * Path part for operation airlineCompanyGetAll
   */
  static readonly AirlineCompanyGetAllPath = '/api/services/app/AirlineCompany/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `airlineCompanyGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  airlineCompanyGetAll$Response(params?: {
  }): Observable<StrictHttpResponse<AjaxResponseOfListOfAirlineDto>> {

    const rb = new RequestBuilder(this.rootUrl, AirlineCompanyService.AirlineCompanyGetAllPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AjaxResponseOfListOfAirlineDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `airlineCompanyGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  airlineCompanyGetAll(params?: {
  }): Observable<AjaxResponseOfListOfAirlineDto> {

    return this.airlineCompanyGetAll$Response(params).pipe(
      map((r: StrictHttpResponse<AjaxResponseOfListOfAirlineDto>) => r.body as AjaxResponseOfListOfAirlineDto)
    );
  }

}
